import { Box, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

interface Props {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export function JobEventsPagination({ page, totalPages, onChange }: Props) {

  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
      }}
    >
      {/* ← Prev */}
      <IconButton
        size="small"
        disabled={!canPrev}
        onClick={() => canPrev && onChange(page - 1)}
        sx={{
          color: canPrev ? "text.primary" : "text.disabled",
          transition: "opacity 120ms ease",
        }}
      >
        <ChevronLeft fontSize="small" />
      </IconButton>

      {/* Dots */}
      <Box sx={{ display: "flex", gap: 0.75 }}>
        {Array.from({ length: totalPages }).map((_, i) => {
          const pageNumber = i + 1;
          const isActive = pageNumber === page;

          return (
            <Box
              key={pageNumber}
              onClick={() => onChange(pageNumber)}
              sx={{
                width: isActive ? 8 : 6,
                height: isActive ? 8 : 6,
                borderRadius: "50%",
                cursor: "pointer",
                backgroundColor: isActive
                  ? "#f78b1f"
                  : "rgba(0,0,0,0.25)",
                transition: "all 150ms ease",
                "&:hover": {
                  backgroundColor: isActive
                    ? "#f78b1f"
                    : "rgba(0,0,0,0.4)",
                },
              }}
            />
          );
        })}
      </Box>

      {/* → Next */}
      <IconButton
        size="small"
        disabled={!canNext}
        onClick={() => canNext && onChange(page + 1)}
        sx={{
          color: canNext ? "text.primary" : "text.disabled",
          transition: "opacity 120ms ease",
        }}
      >
        <ChevronRight fontSize="small" />
      </IconButton>
    </Box>
  );
}
